import type { StickyNavItem } from '../StickyQuickNav'

export const imgTrustProfile1 = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Avatar_2_6f2e7c6937.webp'
export const imgTrustProfile2 = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Avatar_1_6e3979f8dc.webp'
export const imgTrustProfile3 = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Avatar_3_083e7f7222.webp'
export const imgTrustBarDirectInsurer =
  'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/direct_insurer_icon_6eeae3fda0.svg'
export const imgTrustBarInsuranceApp =
  'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/insurance_app_icon_afd2cc7b30.svg'
export const imgTrustBarIrdai = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/irdai_icon_9a26634949.svg'
export const imgAppleIcon = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/ios_icon_7845cf595b.svg'
export const imgGooglePlay = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/google_play_icon_be73fb1823.svg'
export const imgGoogleIcon = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/google_review_icon_bd83deb745.svg'
export const imgReviewX = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/meta_x_icon_a95d71646e.svg'
export const imgReviewLinkedin = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Linkedin_icon_2511d52fd2.svg'
export const imgZeroCommission =
  'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/zero_commission_illustration_f804523953.svg'
export const imgHighIdv = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/high_idv_illustration_6134b8fea1.svg'
export const imgGarage = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/garage_illustration_e65f174c3f.svg'
export const imgVerification = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/verified_illustration_b96536fd9a.svg'
export const imgElecticBike = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/electric_bike_img_94e712e82c.webp'
export const videoClaimProcess = 'https://acko-cms.ackoassets.com/bike_claims_86162a9a28.webm'
export const videoPurchaseProcess = 'https://acko-cms.ackoassets.com/bike_purchase_video_b017dfae72.webm'
export const videoRenewProcess = 'https://acko-cms.ackoassets.com/bike_renewal_video_dd7742e19e.webm'

const imgGuideBook = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/complete_guide_icon_10ec8e9a11.svg'
const imgGuideCustomise = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/IDV_icon_d11308f4be.svg'
const imgGuideShield = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/bike_zero_dep_icon_778f34bff4.svg'
const imgGuideDiscount = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/ncb_icon_385930c58b.svg'
const imgGuideAccident = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/bike_third_party_97045f8d5d.svg'
const imgGuideTasks = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/add_on_icon_c1a9b4ad87.svg'
const imgGuideClaim = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/claim_process_icon_6956efa640.svg'
const imgGuideNotCovered = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/claim_reject_icon_8999ce2d57.svg'
const imgGuidePayment = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/insurance_premium_icon_18d3715e7e.svg'

export const COMP_STICKY_NAV_ITEMS: StickyNavItem[] = [
  { id: 'what-is-comprehensive-bike-insurance', label: 'What is Comprehensive Bike Insurance?' },
  { id: 'vs-third-party', label: 'Comparison of bike insurance policies' },
  { id: 'comp-coverage', label: "What's covered" },
  { id: 'part-coverage', label: 'What each part covers' },
  { id: 'comp-add-ons', label: 'Useful add-ons' },
  { id: 'claim-scenarios', label: 'Why you need it' },
  { id: 'why-acko', label: 'Why buy direct from ACKO' },
  { id: 'trust-reviews', label: 'Why millions trust ACKO' },
  { id: 'claim-stories', label: 'How we earn your trust' },
  { id: 'buy-new', label: 'How to buy comprehensive bike insurance' },
  { id: 'renew-bike', label: 'How to renew comprehensive bike insurance' },
  { id: 'file-claim', label: 'How to file a claim' },
  {
    id: 'why-buy-acko-comprehensive-bike-insurance',
    label: 'Why should you buy ACKO comprehensive bike insurance',
  },
  { id: 'ncb-comprehensive', label: 'What is NCB in comprehensive bike insurance?' },
  { id: 'premium-factors', label: 'What impacts your premium' },
  { id: 'faq', label: 'Frequently asked questions', muted: true },
  { id: 'learn-more', label: 'Learn more', muted: true },
]

export const DEPR_ROWS = [
  { part: 'Glass parts (windshield, mirrors)', standard: '100%', zeroDep: '100%' },
  { part: 'Fiberglass parts', standard: '70%', zeroDep: '100%' },
  { part: 'Paint and materials*', standard: '50%', zeroDep: '100%' },
  { part: 'Plastic, rubber and nylon parts', standard: '50%', zeroDep: '100%' },
  { part: 'Battery', standard: '50%', zeroDep: '100%' },
  { part: 'Metal parts*', standard: '100% (first 6 months), 95% (next 6 months)', zeroDep: '100%' },
  { part: 'Total loss — theft, fire or natural disaster', standard: '100% of IDV value', zeroDep: '100% of IDV value' },
]

export type ProcessStep = {
  num: string
  title: string
  desc: string
}

export const buyNewSteps: ProcessStep[] = [
  {
    num: '1',
    title: 'Enter your bike details',
    desc: 'Open the ACKO app or website. Enter your bike registration number',
  },
  {
    num: '2',
    title: 'Select the comprehensive plan and add-ons',
    desc: 'Choose the Comprehensive plan. Customise your IDV and select add-ons like zero depreciation, engine protection, or personal accident cover.',
  },
  {
    num: '3',
    title: 'Pay and get your instant policy',
    desc: 'Complete payment via UPI, credit card, debit card, or netbanking. Your comprehensive bike insurance policy is issued instantly and available for download.',
  },
]

export const renewSteps: ProcessStep[] = [
  {
    num: '1',
    title: 'Visit our app or website',
    desc: "Select your bike insurance policy, then click 'Renew Now' if it is within 30 days of its expiry date.",
  },
  {
    num: '2',
    title: 'Review your IDV and upgrade add-ons',
    desc: "See what your Insured Declared Value is, and then select 'zero depreciation cover' and/or 'engine protection cover' if you have missed them previously.",
  },
  {
    num: '3',
    title: 'Pay and download instantly',
    desc: 'You can pay via UPI, credit/debit cards, or net banking. Once you renew your policy, it becomes immediately valid without any inspection.',
  },
]

export const claimSteps: ProcessStep[] = [
  {
    num: '1',
    title: 'Open the app and start a claim',
    desc: "Open the ACKO App, then select your comprehensive bike insurance policy and click the 'Claim' button.",
  },
  {
    num: '2',
    title: 'Share the details',
    desc: 'Upload pictures of the damage, state the cause of the accident in detail, and attach the RC and DL. For stolen bikes, upload the FIR copy too.',
  },
  {
    num: '3',
    title: 'Drop your bike for cashless repair',
    desc: 'Take your bike to any mechanic workshop. ACKO pays the workshop directly on your behalf. Most claims are settled within 1 to 7 days.',
  },
]

export const PLATFORM_ICONS: Record<string, string> = {
  twitter: imgReviewX,
  x: imgReviewX,
  linkedin: imgReviewLinkedin,
  playstore: imgGooglePlay,
  play_store: imgGooglePlay,
  appstore: imgAppleIcon,
  app_store: imgAppleIcon,
  google: imgGoogleIcon,
}

export type CmsReview = {
  id: number
  attributes: {
    userName: string
    userFeedback: string
    socialMedia?: string
    userSocialInfo?: string
  }
}

export const FALLBACK_REVIEWS: CmsReview[] = [
  {
    id: 1,
    attributes: {
      userName: 'Rahul Ram',
      userFeedback:
        "The entire repair expenses were covered - I didn't have to pay a single rupee out of pocket. A huge thank you to ACKO Support for their timely support and trustworthy service.",
      socialMedia: 'linkedin',
      userSocialInfo: '',
    },
  },
  {
    id: 2,
    attributes: {
      userName: 'Vadivelan Udayakumar',
      userFeedback:
        'Had a good experience with insurance claim for my bike. The executive Chethan was able to understand the issues and helped with the claim. The process of inspection and claim processing was great and quick.',
      socialMedia: '',
      userSocialInfo: '',
    },
  },
  {
    id: 3,
    attributes: {
      userName: 'Agarwalakash45',
      userFeedback:
        'Filed a bike insurance claim and it got settled in just 1 day! The process was smooth, simple, and stress-free. Really impressed with ACKO - highly recommend!',
      socialMedia: 'app_store',
      userSocialInfo: '',
    },
  },
  {
    id: 4,
    attributes: {
      userName: 'Vikas Saini',
      userFeedback:
        'I initiated a claim for my Splendor bike and it was settled in just 2 days. Everything was online and fast. Best customer service experience ever.',
      socialMedia: '',
      userSocialInfo: '',
    },
  },
  {
    id: 5,
    attributes: {
      userName: 'Ajay shah',
      userFeedback:
        'Great bike insurance plan. Renewal was super easy, claim process was fast. ACKO team was very responsive. Would definitely recommend to all bike owners.',
      socialMedia: 'app_store',
      userSocialInfo: '',
    },
  },
  {
    id: 6,
    attributes: {
      userName: 'Priya Sharma',
      userFeedback:
        'ACKO is really best and simple to use. I have taken my bike insurance from ACKO it was really smooth. The policy itself is very easy to understand and presented in such a simple way.',
      socialMedia: 'google',
      userSocialInfo: '',
    },
  },
]

export const guideCards = [
  {
    icon: imgGuideBook,
    title: 'Standalone own-damage bike insurance',
    desc: 'Understand how standalone own-damage cover protects your bike against accidents, theft, fire, and calamities, plus its exclusions and add-on options.',
    link: 'Explore own-damage cover',
    href: '/two-wheeler-insurance/standalone-own-damage-insurance/',
  },
  {
    icon: imgGuideCustomise,
    title: 'What is IDV and how to calculate it?',
    desc: 'Understanding insured declared value: calculation method, depreciation tables, and impact on your comprehensive premium and claims.',
    link: 'Learn about IDV',
    href: '/two-wheeler-insurance/idv-in-bike-insurance/',
  },
  {
    icon: imgGuideShield,
    title: 'Zero depreciation — is it worth it?',
    desc: 'Cost-benefit analysis, depreciation tables by bike age, real claim comparisons with and without zero dep on your comprehensive plan.',
    link: 'Analyse zero depreciation',
    href: '/two-wheeler-insurance/blogs/what-is-bumper-to-bumper-bike-insurance-and-is-it-worth-buying/',
  },
  {
    icon: imgGuideDiscount,
    title: 'Complete guide on no claim bonus',
    desc: 'How NCB works on your comprehensive plan, transfer process, NCB protection cover, and strategies to maximise your discount.',
    link: 'Know more about NCB',
    href: '/two-wheeler-insurance/no-claim-bonus-in-bike-insurance/',
  },
  {
    icon: imgGuideAccident,
    title: 'Comprehensive vs third-party cover',
    desc: 'Detailed comparison: coverage differences, cost analysis, legal requirements, and decision framework based on bike age and value.',
    link: 'Compare coverages',
    href: '/two-wheeler-insurance/third-party-vs-comprehensive/',
  },
  {
    icon: imgGuideTasks,
    title: 'All comprehensive add-on covers explained',
    desc: 'Complete list: zero dep, engine protect, roadside assistance, consumables, key replacement, return to invoice, NCB protect, and more.',
    link: 'Explore add-ons',
    href: '/two-wheeler-insurance/different-types-of-riders-and-bike-insurance-addons/',
  },
  {
    icon: imgGuideClaim,
    title: 'Comprehensive claim process — step by step',
    desc: 'Documents needed for comprehensive claims, timeline expectations, cashless vs reimbursement process, and common mistakes to avoid.',
    link: 'Complete claim guide',
    href: '/two-wheeler-insurance/claims/',
  },
  {
    icon: imgGuideNotCovered,
    title: 'Why comprehensive claims get rejected',
    desc: 'Top 10 rejection reasons, policy exclusions, what to do if rejected, and how to file successful appeals with real examples.',
    link: 'See how to avoid rejections',
    href: '/ten-reasons-why-bike-insurance-claims-get-rejected/',
  },
  {
    icon: imgGuidePayment,
    title: '5 ways your bike impacts its insurance premium',
    desc: 'See how ex-showroom price, year of manufacture, engine capacity, current market value, and bike model affect your comprehensive premium.',
    link: 'Explore premium factors',
    href: '/articles/two-wheeler-insurance/5-ways-in-which-your-bike-will-impact-its-insurance-cover/',
  },
]
